import { colors, spacing } from "@procore/core-react";

export const HEADER_BORDER = `1px solid ${colors.gray90}`;

/** Inset between the viewer container edge and a Window's draggable bounds. */
export const VIEWER_INSET = spacing.sm;
